export var StringsEN = {
    // Registration and authentication processes
    authentication: {
        register_success: 'Verify your email address using the link that we have sent you',
        error_emailNotVerified: 'The email has not been verified yet',
        resetPasswordemail_sent: 'An email has been sent to ',
        resetPasswordemail_emailNotFound: 'User not found',
        resetPasswordemail_unknownError: 'Unknown error, try again later or contact us if it does not work',
        resetPasswordemail_required: 'New password required',
    },
    // Popups
    popups: {
        input_box_label_user: 'User',
        input_box_label_password: 'Password',
        resetPasswordPopup_title: 'Reset password',
        title_verifyemail: 'Email not verified',
        text_verifyEmail: 'Send verification email to ',
        title_badlyAnonymizedDcm: 'Missing fields in DICOM files',
        text_badlyAnonymizedDcm: "This may cause errors. If you wish to keep these files, click 'Accept'",
        title_nonDcmFiles: 'No compatible DICOM files have been found',
        text_nonDcmFiles: 'None of the selected files can be loaded by FocusedON',
        title_saveChanges: 'Unsaved changes',
        text_saveChanges: 'Do you want to save them?',
        title_unavailable: 'Ongoing maintenance',
        text_unavailable: 'Functionality temporarily unavailable',
        title_setPatientId: 'DICOM data has been anonymized. Set new identifiers to be used in the result files:',
        input_box_label_patientId: 'Patient ID',
        input_box_label_studyId: 'Study ID',
        title_useForTraining: 'Optional',
        text_useForTraining: 'Would you like the changes you made to be used to train the artificial intelligence?',
        title_setFileName: 'Set file name to store the project:',
        input_box_label_fileName: 'File name',
        title_idToken: 'Error',
        text_idToken: 'Unable to get authorization',
    },
    // Modify popup
    modifyPopupStrings: {
        huVisualizationRange_title: 'HU visualization range',
        sliceIndexes_title: 'Slice range',
        sliceIndexes_current: 'Slice index:',
        huAssistance_title: 'HU assistance',
        huAssistance_range: 'HU range:',
    },
    // Buttons
    buttons: {
        button_back: 'Back',
        button_login: 'Login',
        button_accept: 'Accept',
        button_cancel: 'Cancel',
        button_resetPassword: 'Reset password',
        button_logout: 'Logout',
        button_settings: 'Settings',
        button_save: 'Save',
        button_exit: 'Exit',
        button_loginGoogle: 'Login with Google',
    },
    // Errors
    errors: {
        // Login errros 
        login_error_email_or_passowrd: 'Wrong email or password',
        // Format (according to validators for one specific field)
        format_error_email: 'Email address badly formatted',
        format_error_password: 'Password badly formatted',
        // Format (generic validators)
        error_maxValue: 'Value too large',
        error_minValue: 'Value to small',
        error_step: 'Resolution error',
        error_required: 'Required field',
        error_maxLength: 'To many characters',
        error_specialCharacters: 'Special characters are not allowed',
        error_spacesInString: 'Spaces are not allowed',
    },
    // FocusedON String
    fnStrings: {
        button_load: 'Open',
        button_loadDicom: 'Open DICOM',
        button_loadProject: 'Open Project',
        waitingMessage_Login: 'Verifying credentials',
        waitingMessage_LoadDicom: 'Loading files',
        waitingMessage_LoadSeries: 'Anonymizing and loading images',
        waitingMessage_ClassifyingData: 'Segmenting image',
        waitingMessage_GeneratingResults: 'Generating results',
        waitingMessage_ModifyingData: 'Updating segmentation',
        waitingMessage_SavingTrainingData: 'Saving training data',
        waitingMessage_DownloadingProject: 'Downloading project',
        waitingMessage_UploadingProject: 'Loading project',
        button_selectPatient: 'Select patient',
        button_selectStudy: 'Select study',
        button_selectSeries: 'Select series',
        button_selectProcess: 'Select process',
        button_classify: 'Classify',
        button_choose: 'Choose',
        button_modify: 'Modify',
        button_data: 'Data',
        button_vertebralLevels: 'Vertebrae Levels',
        button_artifactsRanges: 'Artifact ranges',
        button_overflowRanges: 'Overflow ranges',
        button_download: 'Download',
        button_results: 'Results',
        button_downloadProject: 'Project',
        button_zip: 'Results (.zip)',
        button_help_docs: 'Documentation',
        button_help_support: 'Technical Support',
        //button_send: 'Send',
    },
    // User feedback strings
    feedbackStrings:{
        successfullySaved: 'Successfully saved',
        unlicensed: 'You do not have a license to load the selected project. Contact support.',
        noRemainingAnalysis: 'No analysis remaining. Contact support.',
        licenseExpired: 'Your license has expired. Contact support.',
        enoughOffsetImages: "Results could not be generated. There are not at least ${0} images above or below the selected range."
    },
    // Available processes
    processesString: {
        vertebralLevels: 'Vertebral levels',
    },
    // Additional data popups
    additionalDataPopupsStrings: {
        // Vertebral levels
        slider_title_vertebral_levels: 'Vertebral levels',
        slider_title_image_quality: 'Image quality',
        title_segmentationDifficulty: 'L1-L5 segmentation difficulty', 
        //slider_title_segmentation_difficulty: 'Segmentation difficulty',
        slider_title_patient_orientation: 'Patient orientation',
        slide_toggle_booleans: ['No', 'Yes'],
        title_ivContrast: 'Intravenous contrast',
        value_venous_ivContrast: 'Venous',
        value_arterial_ivContrast: 'Arterial',
        title_oContrast: 'Oral contrast',
        list_options_oContrast: ['Esophagus and stomach', 'Small intestine', 'Large intestine and ascending colon', 'Colon'],
        title_nArtifactRanges: 'Ranges with artifacts',
        title_nOverflowRanges: 'Ranges with overflow'
    },
    // Spreadsheets page
    spreadsheetsPageStrings : {
        box_top_message_title: 'Automated spreadsheet generation for clinical studies with FocusedON',
        box_top_message_list: [
            'Patients will appear sorted in rows according to their identifier (Patient ID) and the date of data acquisition (Study date)',
            'The Patient ID and Study date fields will be placed in the first columns of the generated spreadsheet',
            'The user must select the remaining fields to be included in the generated spreadsheet',
        ],
        list_title_available_fields: 'Available fields',
        list_title_selected_fields: 'Selected fields',
        button_select_files: 'Select files to be processed',
        waitingMessage_GeneratingFile: 'Generating result file',
    },
    // Landing page strings
    landingPageStrings : {
        button_statistics_title: 'Statistics',
        button_focusedon_title: 'FocusedON',
        button_statistics_text: 'Merge results into a single spreadsheet',
        button_focusedon_text: 'Analize DICOM images using AI',
    }

}